/* mx-parcelas.js v2 — MoxLand
   Exibe "ou até 12x de R$ X,XX sem juros" abaixo do preço do produto.
   Ajustes na CONFIG. Diagnóstico: mensagens "MX-PARCELAS:" no console (F12). */
(function () {
  var CONFIG = {
    MAX_PARCELAS: 12,
    SEM_JUROS_ATE: 12,
    JUROS_AO_MES: 0,
    PARCELA_MINIMA: 5.00,
    TEXTO_SEM_JUROS: "sem juros",
    PIX_DESCONTO_PCT: 5,       /* % de desconto no PIX (0 = esconder linha) */
    PIX_MINIMO: 5.00,          /* preco minimo para exibir a linha do PIX */
    TAMANHO_ICONE: 22          /* tamanho dos ícones em pixels */
  };

  function log(msg) {
    try { console.log("MX-PARCELAS: " + msg); } catch (e) {}
  }

  function parsear(texto) {
    var m = (texto || "").match(/R\$\s*([\d.,]+)/);
    if (!m) return null;
    var v = m[1].replace(/\./g, "").replace(",", ".");
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  function formatar(n) {
    return "R$ " + n.toFixed(2).replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function calcular(preco) {
    for (var n = CONFIG.MAX_PARCELAS; n >= 2; n--) {
      var semJuros = n <= CONFIG.SEM_JUROS_ATE;
      var valor;
      if (semJuros) valor = preco / n;
      else if (CONFIG.JUROS_AO_MES > 0) {
        var i = CONFIG.JUROS_AO_MES / 100;
        valor = preco * (i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
      } else continue;
      if (valor >= CONFIG.PARCELA_MINIMA)
        return { n: n, valor: valor, semJuros: semJuros };
    }
    return null;
  }

  function visivel(el) {
    if (!el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden";
  }

  function depois(a, b) {   /* b vem depois de a no documento? */
    return !!(a.compareDocumentPosition(b) &
              Node.DOCUMENT_POSITION_FOLLOWING);
  }

  /* cacador v3: precos VISIVEIS na zona entre o titulo e o botao de compra */
  function cacarPreco() {
    var todos = document.body.querySelectorAll("*");
    var candidatos = [];
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      if (el.children.length > 0) continue;
      if (el.closest("header, footer, nav, .mx-parcelas")) continue;
      var t = (el.textContent || "").trim();
      if (/^R\$\s*[\d.,]+$/.test(t) && visivel(el)) candidatos.push(el);
    }
    if (!candidatos.length) return null;
    var h1 = document.querySelector("h1");
    var form = document.querySelector("form[action*='/cart/add']");
    /* 1a escolha: visivel, depois do titulo e antes do formulario */
    for (var j = 0; j < candidatos.length; j++) {
      var c = candidatos[j];
      if (h1 && !depois(h1, c)) continue;
      if (form && !depois(c, form)) continue;
      return c;
    }
    /* 2a: visivel depois do titulo */
    for (var k = 0; k < candidatos.length; k++) {
      if (!h1 || depois(h1, candidatos[k])) return candidatos[k];
    }
    return candidatos[0];
  }

  function render() {
    var T = CONFIG.TAMANHO_ICONE;
    var alvo = cacarPreco();
    var caixa = document.querySelector(".mx-parcelas");
    if (!alvo) {
      log("nenhum elemento de preco encontrado nesta pagina.");
      if (caixa) caixa.remove();
      return;
    }
    var preco = parsear(alvo.textContent);
    if (preco == null) { if (caixa) caixa.remove(); return; }
    var r = calcular(preco);   /* pode ser null: PIX aparece mesmo assim */
    var ICONE_CARTAO = '<svg width="' + T + '" height="' + T +
      '" viewBox="0 0 24 24" ' +
      'fill="none" stroke="#000" stroke-width="1.6" stroke-linecap="round" ' +
      'style="vertical-align:-4px;margin-right:6px">' +
      '<rect x="2" y="5" width="20" height="14" rx="2.5"/>' +
      '<line x1="2" y1="9.6" x2="22" y2="9.6"/>' +
      '<line x1="5.6" y1="15" x2="9.4" y2="15"/></svg>';
    if (!caixa) {
      caixa = document.createElement("div");
      caixa.className = "mx-parcelas";
      var bloco = alvo.closest("[class*='price'], [class*='Price']") || alvo;
      bloco.parentNode.insertBefore(caixa, bloco.nextSibling);
      log("preco encontrado (R$" + preco.toFixed(2) +
          "); linha de parcelas inserida.");
    }
    var ICONE_RAIO = '<svg width="' + (T - 3) + '" height="' + (T - 3) +
      '" viewBox="0 0 24 24"' +
      ' fill="none" stroke="#000" stroke-width="1.5" stroke-linejoin="round"' +
      ' style="vertical-align:-4px;margin-right:6px">' +
      '<path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z"/></svg>';
    var linhaPix = "";
    if (CONFIG.PIX_DESCONTO_PCT > 0 && preco >= (CONFIG.PIX_MINIMO || 0)) {
      var precoPix = preco * (1 - CONFIG.PIX_DESCONTO_PCT / 100);
      linhaPix = '<div class="mx-pix">' + ICONE_RAIO + '<b>' +
        formatar(precoPix) + '</b>&nbsp;no PIX</div>';
    }
    var linhaParcelas = "";
    if (r) {
      var texto = "ou até " + r.n + "x de " + formatar(r.valor) +
        (r.semJuros ? " " + CONFIG.TEXTO_SEM_JUROS : "");
      linhaParcelas = '<div class="mx-parcelas-linha">' + ICONE_CARTAO +
        texto + '</div>';
    }
    var conteudo = linhaPix + linhaParcelas;
    if (!conteudo) { caixa.remove(); return; }
    if (caixa.getAttribute("data-mx") !== conteudo) {
      caixa.setAttribute("data-mx", conteudo);
      caixa.innerHTML = conteudo;
    }
  }

  function css() {
    var s = document.createElement("style");
    s.textContent =
      ".mx-parcelas{margin-top:6px;font-size:.95em;}" +
      ".mx-pix{margin-bottom:3px;}" +
      ".mx-pix b{font-weight:700;}" +
      ".mx-parcelas-linha{opacity:.8;}";
    document.head.appendChild(s);
  }

  function iniciar() {
    if (location.pathname.indexOf("/products/") === -1) return;
    css();
    render();
    var agendado = null;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.classList && t.classList.contains("mx-parcelas")) return;
      }
      clearTimeout(agendado);
      agendado = setTimeout(render, 250);
    }).observe(document.body,
      { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
})();